import React, { useEffect, useState } from "react";
import ReactSlider from "react-slider";
import HeadLines from "../HeadLines";
import InputText from "../InputText";
import "../../CommonComponents/ExperimentalFilterComponent/filter.css";
import s from "./styles.module.css";
const SliderWithDisplay = (props) => {
  const {
    stateRestored,
    minOfRange = 0, //PASS THIS AS NUMBER
    maxOfRange = 0, //PASS THIS AS NUMBER
    minVal, //PASS THIS AS NUMBER
    maxVal, //PASS THIS AS NUMBER
    onChange,
    displayTitle1,
    showDisplayTitles = true,
    displayTitle2,
    titleClassName = "",
    title = "",
    showTitle = false,
    displayTitleClassName = "",
    quntityRangeClassName = "",
    minMaxTextClassName = "",
    forceUpdate,
    setForceUpdate,
    gapClassName="gap16",
  } = props;

  const [minTextBoxValue, setMinTextBoxValue] = useState(minVal);
  const [maxTextBoxValue, setMaxTextBoxValue] = useState(maxVal);
  useEffect(() => {
    if (stateRestored) {
      setMinTextBoxValue(minVal);
      setMaxTextBoxValue(maxVal);
    }
  }, [stateRestored]);

  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(0);
      setMinTextBoxValue(minVal);
      setMaxTextBoxValue(maxVal);
    }
  }, [minVal, maxVal]);

  const handleMinTextBoxChange = (e) => {
    const { value } = e.target;
    if (value.trim() === "" || +value < minOfRange || +value >= maxVal) {
      setMinTextBoxValue(value);
      onChange([minOfRange, maxVal]);
    } else {
      setMinTextBoxValue(value);
      onChange([+value, maxVal]);
    }
  };
  const handleMaxTextBoxChange = (e) => {
    const { value } = e.target;
    if (value.trim() === "" || +value > maxOfRange || +value <= minVal) {
      setMaxTextBoxValue(value);
      onChange([minVal, maxOfRange]);
    } else {
      setMaxTextBoxValue(value);
      onChange([minVal, +value]);
    }
  };
  // useEffect(() => {
  //   setMinTextBoxValue(minVal);
  // }, [minVal]);
  // console.log(minVal, maxVal);
  return (
    <>
      {showTitle && <HeadLines className={titleClassName} text={title} />}
      <div className="slider-main margin-top12 margin-bottom12">
        <div className="slider-container">
          <ReactSlider
            value={[minVal, maxVal]}
            className="slider__custom"
            trackClassName="tracker"
            min={minOfRange}
            max={maxOfRange}
            minDistance={1}
            step={1}
            withTracks={true}
            pearling={true}
            renderThumb={(props) => {
              return (
                <div {...props} className="thumb">
                  <div className="mid-circle"></div>
                </div>
              );
            }}
            renderTrack={(props) => {
              return <div {...props} className="track"></div>;
            }}
            onChange={([min, max]) => {
              setMinTextBoxValue(min);
              setMaxTextBoxValue(max);

              onChange([min, max]);
            }}
          />
        </div>
      </div>
      <div className={`d-flex ${gapClassName}`}>
        <div className="flex1">
          {showDisplayTitles && (
            <HeadLines
              className={`
                               font-weight700
                               font-size12
                               line-height14
                               letter-spacing025
                               colorDark9
                               ${s["margin-bottom4"]}
                               ${displayTitleClassName}
                               `}
              text={displayTitle1}
            />
          )}
          <InputText
            className={`
                      lightBorder 
                      boxRadius4 
                      width-100 
                      padding8
                      font-weight400
                      font-size12
                      line-height14
                      letter-spacing025
                      colorDark2
                      ${quntityRangeClassName}
          `}
            value={minTextBoxValue}
            onChange={handleMinTextBoxChange}
            type="number"
            onBlur={() => setMinTextBoxValue(minVal)}
          />
          <div
            className={`d-flex
          font-size10
          line-height12
          colorDark9
          gap2 ${s["margin-top5"]} ${minMaxTextClassName}`}
          >
            <HeadLines>Minimum:</HeadLines>
            <HeadLines className={"font-weight500"} text={minOfRange} />
          </div>
        </div>
        <div className="flex1">
          {showDisplayTitles && (
            <HeadLines
              className={`
                               font-weight700
                               font-size12
                               line-height14
                               letter-spacing025
                               colorDark9
                               ${s["margin-bottom4"]}
                               ${displayTitleClassName}
                               `}
              text={displayTitle2}
            />
          )}
          <InputText
            className={`
                      lightBorder 
                      boxRadius4 
                      width-100 
                      padding8
                      font-weight400
                      font-size12
                      line-height14
                      letter-spacing025
                      colorDark2
                      ${quntityRangeClassName}
                    `}
            value={maxTextBoxValue}
            onChange={handleMaxTextBoxChange}
            type="number"
            onBlur={() => setMaxTextBoxValue(maxVal)}
          />
          <div
            className={`d-flex
          font-size10
          line-height12
          colorDark9
          gap2 ${s["margin-top5"]} ${minMaxTextClassName}`}
          >
            <HeadLines>Maximum:</HeadLines>
            <HeadLines
              className={"font-weight500"}
            >{`${maxOfRange}`}</HeadLines>
          </div>
          {/* <DecoratedInputText
            prependText={prependText}
            value={maxVal}
            divClassName="backgroundLightBrown 
          lightBorder 
          boxRadius4 
          width-100 
          padding8
          font-weight400
          font-size12
          line-height14
          letter-spacing025
          colorDark2"
          /> */}
        </div>
      </div>
    </>
  );
};

export default SliderWithDisplay;
